<!--仓库 批量打印条码-->
<template>
  <el-dialog
    :title="getTitle()"
    :visible.sync="dialogSeeVisible"
    center
    :close-on-click-modal="false" :append-to-body="true"
    custom-class="medium-dialog">
    <div ref="print1" style="width: 100%;margin: 0 auto;">
      <p :style="{display:showtitle1,textAlign:'center',fontSize:'18px',lineHeight:'40px'}">{{getTitle()}}</p>
      <table cellspacing="0" cellpadding="0" border="0" style="border-collapse:collapse;width:100%;"
             class="query-table">
        <tr class="noborder">
          <td align="right" width="60">入&nbsp;&nbsp;&nbsp;&nbsp;库：</td>
          <td width="120">
            <el-select v-model="controlData.cangkucode" placeholder="请选择" size="mini" @change="changename">
              <el-option
                v-for="item in jxcstoreData"
                :key="item.cangkucode"
                :label="item.cangkuname"
                :value="item.cangkucode">
              </el-option>
            </el-select>
          </td>
          <td align="right"  width="80">类&nbsp;&nbsp;别：</td>
          <td  width="160">
            <CommonTree ref="treeSeed" :inputSize="'mini'" :defineDataSource="true" @bindData="bindData"
                        :treeWidth="450"
                        :onlyShowGroupType="true" :needTopNode="false"
                        :treeHeight="300" :searchText="form.seedname"
                        @check="checktree1"></CommonTree>

          </td>
          <td width="80"> <el-button size="mini" type="success" @click.stop.prevent="showGoodDetailSel()">选择商品</el-button></td>
          <td width="200"><el-date-picker style="width:100%"  v-model="printdate" :value-format="'yyyy-MM-dd'" type="date"  size="mini"  placeholder="补打条码日期">
          </el-date-picker>  </td>
          <td>总数:{{totalnumber}}</td>
        </tr>
        <tr class="noborder">
          <td colspan="7">
            <el-table
              :data="tableData"
              size="mini"
              stripe
              border
              style="width: 100%;">
              <el-table-column
                type="index"
                :index="indexMethod"
                align="center"
                label="序号"
                width="50">
              </el-table-column>
              <el-table-column
                prop="seedname" :show-overflow-tooltip="true"
                label="商品名称"
                align="center"
                width="120"
                header-align="center">
              </el-table-column>
              <el-table-column
                prop="seedcode"
                label="编码"
                align="center"
                width="50" :show-overflow-tooltip="true"
                header-align="center">
              </el-table-column>
              <el-table-column
                prop="model"
                label="型号"
                width="100"
                align="center"
                header-align="center">
              </el-table-column>
              <el-table-column
                prop="color"
                label="色号"
                width="80"
                align="center"
                header-align="center">
              </el-table-column>
              <el-table-column
                prop="totalnumber"
                label="数量"
                align="center"
                width="90"
                header-align="center">
                <template slot-scope="scope">
                  <el-input style="width: 100%" size="small" v-model="scope.row.totalnumber"
                            :ref='scope.row.id'
                            onfocus="this.select()"
                            @keyup.enter.native="validateCounts(scope.row,scope.$index, $event,'')"
                            @keyup.down.native="validateCounts(scope.row,scope.$index, $event,'')"
                            @keyup.up.native="validateCounts(scope.row,scope.$index, $event,'')"
                            @change="totalNumber"></el-input>
                </template>
              </el-table-column>
              <el-table-column
                prop="barcodes"
                label="条码"
                align="left"
                header-align="center">
                <template slot-scope="scope">
                  <div v-for="item in scope.row.barcodes" :key="item.storegoodsbarcode">
                    {{item.storegoodsbarcode}}<i class="el-icon-close" style="cursor: pointer" @click="clearBar(item.storegoodsbarcode,scope.row)"></i>
                  </div>
                </template>
              </el-table-column>
              <!--<el-table-column-->
                <!--prop="printdate"-->
                <!--label="条码日期"-->
                <!--align="center"-->
                <!--width="150"-->
                <!--header-align="center">-->
                <!--<template slot-scope="scope">-->
               <!---->
                <!--</template>-->
              <!--</el-table-column>-->
              <el-table-column label="操作" align="center" width="100">
                <template slot-scope="scope">
                  <el-button size="mini" type="danger"
                             @click="handleDelete(scope.$index, scope.row)">删除
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </td>
        </tr>
      </table>
    </div>
    <div slot="footer" class="dialog-footer no-print">
      <el-button @click="dialogSeeVisible = false" size="mini">关 闭</el-button>
      <!--<el-button @click="createBarcode('ewm')" :loading="loading" type="success" size="mini" icon="el-icon-menu">打印二维码</el-button>-->
      <el-button @click="createBarcode('')" :loading="loading" type="primary" size="mini" icon="el-icon-s-data">打印条码</el-button>
      <el-button @click="createBarcode('tm25*95')" :loading="loading"  size="mini" icon="el-icon-s-data">25*95码</el-button>
      <el-button @click="createBarcode('tm25*95T')" :loading="loading"  size="mini" icon="el-icon-s-data">25*95码（反）</el-button>
      <el-button @click="createBarcode('tm32*14')" :loading="loading"  size="mini" icon="el-icon-s-data">32*14码</el-button>
    </div>
    <BatchBuyFormProperties ref="batchBuyFormProperties" @afterSelectCode="afterSelectCode" :initnum="false"></BatchBuyFormProperties>
  </el-dialog>
</template>


<script>

  import {suppliers} from '@/api/set/externaldept';
  import {createGoodsbarcode} from '@/api/set/jxcgoodsbarcode';
  import {sortByKey} from '@/api/dateUtil';
  import {barcodePrint} from '@/api/file';
  import {getRemark} from '@/plugin/ordercommon'
  import BatchBuyFormProperties from '../buyagreement/BatchBuyFormProperties'
  import {cusandptbyind} from '@/api/set/jxcstore';
  import {listgoodsframe, getDetail, getGoodsTree} from '@/api/set/jxcgooddetail'
  import {loadSpecFrame} from '@/plugin/ordercommon'
  import {batchSave} from '@/api/set/jxcstoregoodsbarcode';

  export default {
    name: 'Storeprintbarcode',
    data() {
      let yearnow = new Date().getFullYear()
      let monthnow = new Date().getMonth() + 1
      return {
        ssotoken:"",
        website:"",
        userInfoModel: {},
        data: '2',
        allSupply:false,
        didata: '',
        printdate:'',
        iddata: '',
        dialogFormVisible: false,
        title: "",
        index: -99,
        seedgoods: [],
        dialogSeeVisible: false,
        formLabelWidth: '120px',
        groupguid: '',
        maxyear: yearnow,
        maxmonth: monthnow,
        catattributes:{},
        remark: '',
        cangkucode: '',
        cangkuname: '',
        unitguid: "",
        column: [],
        ptableData: [],
        controlData: {cangkucode:'',cangkuname:''},
        showtitle1: "none",
        jxcstoreData: [],
        form: {  //表单数据
          unitguid: "",
          bookstr: "",
          seedcode: "",
          seedname: "",
          seedinfo: "",
        },
        tracknum: '',//供应商单号
        logisticstracknum: '',//跟踪单号
        seedcodeData: [],//选择类别后的商品
        seedcodes: '',
        pingpainame:'',
        tableData: [],
        loading: false,//防止多次提交
        totalnumber: 0,
        pcustomerserial: ''
      }

    },
    methods: {
      guid() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
          var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
          return v.toString(16);
        });
      },
      //回车跳入下一行
      validateCounts(row, index, e ,pre) {
        var keyCode = e.keyCode || e.which || e.charCode;
        if (keyCode == 40 || keyCode === 13) {//回车，下方向键
          this.$refs[pre+row.id].blur()
          if (this.tableData.length - 1 === index) {
            index = -1
          }
          this.$refs[pre + (index + 1)].focus();
        } else if (keyCode == 38) {//上方向键
          this.$refs[pre+row.id].blur()
          if (index === 0) {
            index = this.tableData.length
          }
          this.$refs[pre + (index - 1)].focus();
        }
      },
      //给tableData 添加 id，共回车使用
      indexMethod(index) {
        this.tableData[index].id = index
        return index + 1;
      },
      clearBar(storegoodsbarcode,item) {
        for (let i in item.barcodes) {
          if (item.barcodes[i].storegoodsbarcode == storegoodsbarcode) {
            item.barcodes.splice(i, 1)
            break;
          }
        }
        item.totalnumber=item.barcodes.length
        this.totalNumber()
      },
      //购买总数
      totalNumber() {
        this.totalnumber = 0
        for (let i in this.tableData) {
          this.totalnumber = this.totalnumber + parseInt(this.tableData[i].totalnumber)
        }
      },
      //显示商品选择页面
      showGoodDetailSel() {
        if (this.seedcodeData.length == 0) {
          this.$message.error("品牌下没有商品");
          return
        }
        for (let i in this.seedcodeData) {
          this.seedcodeData[i].totalnumber = 0
        }
        //参数  true 显示库存，seedcode分类，cangkucode 仓库，seedcodeData 分类下的商品
        this.$refs.batchBuyFormProperties.initData(true, this.form.seedcode, this.controlData.cangkucode, this.seedcodeData, this.controlData.pcustomerserial)
      },
      //选择商品之后执行
      afterSelectCode(arr) {
        let count = 0;//记录当前订单是否需要弹出提示
        for (let i in arr) {
          let biaoji = 0
          for (let j in this.tableData) {
            //判读该商品是否属于
            if (this.tableData[j].seedcode == arr[i].seedcode && this.tableData[j].model == arr[i].model && this.tableData[j].color == arr[i].color) {
              biaoji = 1
              this.tableData[j].totalnumber = arr[i].totalnumber;//更新数量
              count++;
              break
            }
          }
          if (biaoji == 0) {
            this.tableData.push({
              seedcode: arr[i].seedcode,
              seedname: arr[i].seedname,
              color:arr[i].color,
              model:arr[i].model,
              categorycode: arr[i].categorycode,
              totalnumber: arr[i].totalnumber,
              formproperty: '[{}]',
              packagesize:'{"M":"'+arr[i].model+'","C":"'+arr[i].color+'"}',
              onlycode:'',
              printdate:'',
              barcodes:[]
            })
          }
        }
        //从小到大排序
        this.tableData.sort(function (a, b){
          if (a.model == b.model)
            return a.color.localeCompare(b.color);
          else
            return a.model.localeCompare(b.model);
        });
        this.totalNumber()
        // if (count > 0) {
        //   this.$message({
        //     message: "商品已存在！",
        //     type: 'info'
        //   })
        // }
      },
      //删除明细
      handleDelete(index, row) {
        this.tableData.splice(index, 1)
        this.totalNumber()
      },
      //页面标题
      getTitle() {
        let result = ""
        result += "打印条码"
        return result
      },
      checktree1(guids, names, arr) {
        if(guids.length<9)
          return;

        this.seedcodeData = []
        this.form.seedcode = guids
        this.form.seedname = names
        this.form.seedinfo = ";" + guids + "," + arr[0].parentId + ";"
        this.catattributes=arr[0].attributes;
        this.pingpainame=guids.length==12?(this.$refs.treeSeed.getNode(guids.substr(0, guids.length - 3)).label):'';

        if (this.form.seedname == "") {
          this.$message({
            message: '请选择类别',
            type: 'error'
          })
          return
        }
        listgoodsframe({
          categorycode: this.form.seedcode,
          filltemplate: '80',
        }).then(response => {
          this.seedcodeData = response.data.obj
          if (this.seedcodeData.length > 0) {
            for (let i in this.seedcodeData) {
              this.seedcodeData[i].totalnumber = 0
            }
            this.showGoodDetailSel();
          } else {
            // this.$message({
            //   message: '该系列没有备货商品',
            //   type: 'warning'
            // })
            return
          }

        }).catch((error) => {
          console.log(error)
        });

      },
      //商品树
      bindData() {
        this.$refs.treeSeed.bindData(() => {
          return getGoodsTree({onlyShowGroupType:true,categorystarts:'002;003;005;004;006'})
        })
      },
      //备注格式化
      getLiuYan(remark) {
        return getRemark(remark);
      },
      print1() {
        this.showtitle1 = ""
        this.$nextTick(() => {
          this.$print(this.$refs.print1)
          this.showtitle1 = "none"
        })
      },
      createBarcode(printtype) {
        var number = 0;
        for (let i in this.tableData) {
          var tn = this.tableData[i].totalnumber | 0;
          var scancount = this.tableData[i].barcodes.length;

          if (tn <= 0) {
            this.$message({message: '数量必须大于0！', type: 'error'})
            return;
          }
          if (tn > scancount) {
            number += tn - scancount;
          }
        }

        this.loading = true;
        var saveBar = []
        if (number > 0) {
          //获取条码
          createGoodsbarcode({number: number,printdate:this.printdate}).then(response => {
            if (response.data.code == 0) {
              var codePre = response.data.codepre;
              var num = response.data.num;
              //item.model + item.color + '-' +
              for (let i in this.tableData) {
                var item = this.tableData[i];
                var tn = item.totalnumber | 0;
                var scancount = item.barcodes.length;
                for (let j = 0; j < tn - scancount; j++) {
                  var bc = codePre + this.padleft((num - number + 1).toString(), 3, '0');
                  item.barcodes.push({
                    storegoodsbarcode: bc
                  });
                  saveBar.push({
                    storegoodsbarcode: bc,
                    cangkucode: this.controlData.cangkucode,
                    inordernum: 'createbarcode',
                    seedcode: item.seedcode,
                    packagesize: item.packagesize,
                    intime:this.printdate
                  });
                  number = number - 1;
                }
              }
              batchSave({caiGouRukuData: JSON.stringify(saveBar),erpbarcodes:null}).then(resSave => {//保存成功开始打印
                if (resSave.data.code == 0) {
                  this.barcodePDF(printtype);
                } else {
                  this.tableData = []
                  this.loading=false
                  this.$message({message: '条码生成失败，请重新选择！', type: 'error'})
                  return;
                }
              })
            }
          });
        } else {
          this.barcodePDF(printtype);
        }
      },
      barcodePDF(printtype) {
        var barcode = [];
        for (let i in this.tableData) {
          var item = this.tableData[i];
          for (let j in item.barcodes) {
            barcode.push({
              barcode: item.barcodes[j].storegoodsbarcode, seedcode: item.seedcode, model: item.model, color: item.color
            });
          }
        }
        barcodePrint(barcode, null,printtype);
        this.loading = false;
      },
      padleft(ret,width,padChar) {
        while (ret.length < width) {
          ret = padChar + ret;
        }
        return ret;
      },
      show() {
        this.form.seedcode = ""
        this.form.seedname = ""
        this.tableData = []
        this.dialogSeeVisible = true;
      },
      //仓库选择后获取仓库名
      changename(val) {
        this.tableData=[]
        for (let i in this.jxcstoreData) {
          if (this.jxcstoreData[i].cangkucode == val) {
            this.controlData.cangkuname = this.jxcstoreData[i].cangkuname;
          }
        }
      },
      getRemark(remark) {
        if (remark) {
          try {
            let temp = JSON.parse(remark)
            temp.forEach(item => {
              if (item.type == "客户留言") {
                return item.msg
              }
            })
          } catch (ex) {
          }
        }
        return ""
      },
      initData(row) {
        this.initForm();
        if (row == null)
          return;
        this.controlData.cangkucode = row.cangkucode;
        this.controlData.cangkuname = row.cangkuname;

        if (this.$refs.form1 !== undefined) {
          this.$refs.form1.resetFields();
          this.form.bookstr = ""
          this.form.seedcode = ""
          this.form.seedname = ""
          this.form.seedinfo = ""
          this.catattributes={}
        }
        this.index = -99
        this.form.seedcode = ''
        this.form.seedname = ''
      },
      initForm() {
        this.pcustomerserial=''
        this.ptableData=[]
        this.form.seedname=''
        this.form.seedcode=''
        this.form.bookstr = ""
        this.controlData.pcustomerserial = ''
        this.controlData.pcustomer =''
        this.controlData = {cangkucode: this.controlData.cangkucode}
        this.groupguid = ""
        this.column = []
        this.ssotoken = ""
        this.tableData = []
        this.unitguid = ""
        this.tracknum = ''
        this.logisticstracknum = ''
        this.loading = false
        this.totalnumber = 0
      }
    },
    mounted() {
      let temp = localStorage.getItem("hpapi_userInfoModel")
      if (temp) {
        this.userInfoModel = JSON.parse(temp);
      }
      cusandptbyind().then(response => {
        this.jxcstoreData = response.data.obj
        this.controlData.cangkucode = this.jxcstoreData[0].cangkucode;
      })

    },

    components: {
      BatchBuyFormProperties,
    }

  }
</script>

<style scoped>
  .query-table td {
    border: 1px solid #E0DFDF;
    vertical-align: center;
    height: 22px;
    line-height: 16px;
    padding: 2px;
    font-size: 12px;
  }

  .query-table td.content {
    text-align: center;
  }

  .noborder td {
    border: none;
    font-size: 12px;
  }

  .gray1 td {
    color: #C0C4CC;
    background-color: #ebeef5;
  }

  .gray1 input {
    display: none;
  }

</style>





// WEBPACK FOOTER //
// src/components/testorder/warehouse/Storeprintbarcode.vue